import React from 'react'
import { TextField } from '@mui/material'
import { StyledflexSpacebetween, StyledLeadContainer } from './Styled'
import { handleValidateCodevalue } from '../Utility/constant'
import { useSelector } from 'react-redux'
import TextFiledWithLabel from './TextFieldWithLabel'

export const WhoColumns = ({searchState , handleOnChange}) => {
    
      const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  return (
    <StyledflexSpacebetween>
            <div className='date-container-search'>
                        <TextFiledWithLabel
                            id="createdFrom"
                            label= {handleValidateCodevalue(internationalise,'COMMON_CREATED_FROM')}
                            name="createdFrom"
                            type="date"
                            value={searchState?.createdFrom || ""}
                            onChange={handleOnChange}
                        />
                        <TextFiledWithLabel
                            id="createdTo"
                            label={handleValidateCodevalue(internationalise,'COMMON_CREATED_TO')}
                            type="date"
                            name="createdTo"
                            value={searchState?.createdTo || ""}
                            onChange={handleOnChange}
                        />
            </div>
            <div className='date-container-search'>
                        <TextFiledWithLabel
                            id="updatedFrom"
                            label={handleValidateCodevalue(internationalise,'COMMON_UPDATED_FROM')}
                            type="date"
                            name="updatedFrom"
                            value={searchState?.updatedFrom}
                            onChange={handleOnChange}
                        />
                        <TextFiledWithLabel
                            id="updatedTo"
                            label={handleValidateCodevalue(internationalise,'COMMON_UPDATED_TO')}
                            type="date"
                            name="updatedTo"
                            value={searchState?.updatedTo}
                            onChange={handleOnChange}
                        />
            </div>
    </StyledflexSpacebetween>
  )
}
